
//Shaders need to expose a_position and a_texCoord 

export class Effect {
  constructor(aGl){
    this.gl = aGl;
    this.program = this.gl.createProgram();
  }

  addShader (aShaderSource, aShaderType) {
    //create the shader.
    var lShader = this.gl.createShader(aShaderType);
    //load the shader source
    this.gl.shaderSource(lShader, aShaderSource);
    //compile the shader
    this.gl.compileShader(lShader);

    //throw exception if the shader doesn't compile
    if (!this.gl.getShaderParameter(lShader, this.gl.COMPILE_STATUS)) {
        var lastError = this.gl.getShaderInfoLog(lShader);
        this.gl.deleteShader(lShader);
        throw lastError;
    }

    //attach the shader to the program
    this.gl.attachShader(this.program, lShader);
  };

  activate(){
      this.gl.useProgram(this.program);
  }

}


/** WEBPACK FOOTER **
 ** ./src/cdl/style/glEffects/effect.js
 **/